import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState([]);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 fileNumber: GetLocal('FileNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowRenovationStatusReview", inputValue, ShowServiceResultSuccess);
    }, []);	
	
    const ShowServiceResultSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div> 
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			{getServiceResult ? <div>
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.RenovationStatusReviewList}
				customHeaders={{
					"SerialNumber": "سریال",
					"Year": "سال",
					"Amount": "مبلغ قابل پرداخت",
					"IssueDate": "تاریخ صدور",
					"PaymentDeadline": "مهلت پرداخت",
					"PaymentDate": "تاریخ پرداخت",
					"PaymentAmount": "مبلغ پرداختی",
					"Status": "وضعیت",
				}}		
			/>			
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>
    );
}
